import { render, staticRenderFns } from "./Popup-social.vue?vue&type=template&id=120ac011&"
import script from "./Popup-social.vue?vue&type=script&lang=js&"
export * from "./Popup-social.vue?vue&type=script&lang=js&"
import style0 from "./Popup-social.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports